import { render, staticRenderFns } from "./bargainRecord.vue?vue&type=template&id=f9c2b88e&scoped=true"
import script from "./bargainRecord.vue?vue&type=script&lang=js"
export * from "./bargainRecord.vue?vue&type=script&lang=js"
import style0 from "./bargainRecord.vue?vue&type=style&index=0&id=f9c2b88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c2b88e",
  null
  
)

export default component.exports